import axios from 'axios';
import JustValidate from 'just-validate';
// import { Rules } from "just-validate/dist/modules/interfaces";
import checkCookie from './check-cookie';

declare let core_object: any;

export default class sendComment{

    protected elForm: string;
    protected elFormAlert: string;
    protected elBtn: string;
    protected elSectionList: string;
    protected elFormSpin: string = 'bgdrop-spin';
    
    protected url_api_write_comment: string;

    /**
     * Constructor
     * @param elBtn
     */
    constructor(
        elForm: string,
        elFormAlert: string,
        elBtn: string,
        elSectionList: string
    ){
        
        this.elForm = elForm;
        this.elFormAlert = elFormAlert;
        this.elBtn = elBtn;
        this.elSectionList = elSectionList;
        this.url_api_write_comment = core_object.rest_urls.comments_write;

    }

    /**
     * Validation form
     * @returns 
     */
    validateForm(){
        
        const _that = this;

        const form = document.querySelector(this.elForm);

        if(form == null){
            
            return;

        }

        const modCheckCookie = new checkCookie();

        const cookie_exist = modCheckCookie.cookieExist();

        if(cookie_exist == true){
        
            const validation = new JustValidate(this.elForm, {
                errorFieldCssClass: 'is-invalid border border-color11-400',
                errorLabelCssClass: 'just-validate-error-label flex flex-row flex-wrap basis-full w-full mt-1',
                errorsContainer: document.querySelector('#send-comment-error-container'),
                focusInvalidField: true,
                lockForm: true,
            });
    
            validation.addField('#comment-text', [
                {
                    rule: 'required',
                    errorMessage: core_object.error_messages.field_required,
                }
            ])
            .onSuccess((event: any) => {
                    
                    event.preventDefault();
                
                    _that.addComment(event?.currentTarget);
                    
            });
    
            return validation;

        } else {
            
            // Btn
            const btn = document.getElementById(this.elBtn);

            btn?.addEventListener("click", function(e){
                e.preventDefault();

                return false;

            });
            
            return false;

        }

    }

    /**
     * Add comment
     * @param form 
     */
    protected addComment(form: HTMLFormElement){
        
        const _that = this;

        // Section list comments
        const section = document.getElementById(_that.elSectionList);

        // Btn
        const btn = document.getElementById(this.elBtn);

        // Init spin
        const spin = _that.btnSpin();
            
        // Set disabled attribute
        btn?.setAttribute('disabled', '');

        // Append spin to button
        btn?.append(spin);

        // Get form data
        const data = new FormData(form); 
        
        // Conver form data to string
        const datastring = new URLSearchParams(data as any).toString();

        // Init post data
        const post_data = {
            'fields': datastring
        };

        // Create query string
        const queryString = new URLSearchParams(post_data).toString();

        // Call ajax
        axios.post(_that.url_api_write_comment, queryString, {
            
            validateStatus: function(status){
              return status <= 200;
            }

        })
        .then(function (response: any) {

            // Remove alert box
            _that.removeAlertBox(form);

            // Remove spin
            spin.remove();
                
            // Remove disabled attribute
            btn?.removeAttribute('disabled');
            
            // Response status
            const response_status: boolean = response.data.status;
                
            // True
            if(response_status == true){
                
                // Reset form
                form.reset();
                
                const response_comment: string = response.data.comment;
                
                section?.insertAdjacentHTML('afterbegin', response_comment);

            }

        })
        .catch(function (error: any) {
            
            //  Get status
            const errorStatus = error.response.status;

            if(errorStatus == 201){
            
                // Get errors
                const errors = error.data.errors;
                
                if(Array.isArray(errors)){
                    
                    errors.forEach(function(error){
                        
                        const alert = _that.alertBox(error);
                        form.prepend(alert);

                    });

                }else{
                    
                    const alert = _that.alertBox(errors);
                    form.prepend(alert);

                }

            }

            // Remove spin
            spin.remove();

            // Remove disabled attribute
            btn?.removeAttribute('disabled');

        });

    }

    /**
     * Create spin
     * @returns 
     */
    protected btnSpin(){
        
        const spin = document.createElement('i');

        spin.setAttribute('id', this.elFormSpin);
        spin.setAttribute('class', 'fa-solid fa-circle-notch fa-spin ml-1 mt-1');

        return spin;

    }

    /**
     * Alert Box
     * @param text 
     * @returns 
     */
    protected alertBox(text: string){

        const alert = document.createElement("div");

        alert.setAttribute('role', 'alert');
        alert.classList.add(this.elFormAlert, 'flex', 'basis-full', 'w-full', 'p-4', 'mb-4', 'rounded', 'fluid-text-sm', 'text-red-800', 'bg-red-50');
        alert.innerHTML = '<svg aria-hidden="true" class="flex-shrink-0 inline w-5 h-5 mt-2 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path></svg>';
        alert.innerHTML += '<div><span class="font-bold">' + core_object.general_message.error + '</span> ' + text + '</div>';

        return alert;
        
    }

    /**
     * Remove alert box
     */
    protected removeAlertBox(form: HTMLFormElement){

        if(form != null){
            
            const alerts = Array.from(form.getElementsByClassName(this.elFormAlert)) as any;

            alerts.forEach(alert => {

                alert.remove();

            });
        
        }

    }

}